module.exports = __webpack_public_path__ + "static/img/wechat-logo.789d4bd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat-logo.jpeg
// module id = iXXh
// module chunks = 1